import BaseComponent from "../../baseComponent.js"
import DatasetService from "../../../core/services/datasetService.js";
import WidgetService from "../../../core/services/widgetService.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import styles from "./styles.scss";

export default class Subscription extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      datasets: []
    };
    this.pendingSubscriptions = [];
    this.missingSubscriptionMap = {};
    this.loaded = false;
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  componentDidMount() {
    this.$modal = $("#subscription-modal");
    this.$modal.modal({
      dismissible: false
    });
    this.subscribe(InternalEvent.Dashboard.OPEN_SUBSCRIPTION_POPUP, payload => {
      if (!this.loaded) {
        this.missingSubscriptionMap = payload.map;
        if (payload.notSubscribedDatasets.length > 0) {
          this.loadDatasets(Array.from(new Set(payload.notSubscribedDatasets)))
            .then(() => {
              this.loaded = true;
              this.show();
            });
        }
      }
    });
  }

  shouldDisplaySubscribeAll(datasets) {
    datasets.forEach(d => {
      if (d.licenses.length > 1) {
        return false;
      }
    });
    return true;
  }

  loadDatasets(datasetIds) {
    const promises = datasetIds.map(datasetId => DatasetService.getDataSetById(datasetId, true));
    return Promise.all(promises)
      .then(datasets => {
        this.setState({
          displaySubscribeAll: this.shouldDisplaySubscribeAll(datasets),
          datasets
        });
      });
  }

  subscribeAll() {
    this.state.datasets.forEach(dataset => {
      if (!dataset.licenses[0].subscribed) {
        this.subscribeLicense(dataset.persistenceId, dataset.licenses[0].persistenceId);
      }
    });
  }

  subscribeLicense(datasetId, licenseId) {
    const isPending = this.pendingSubscriptions.find(r => r.datasetId === datasetId && r.licenseId === licenseId);
    if (!isPending) {
      this.pendingSubscriptions.push({datasetId, licenseId});
      DatasetService.subscribeDataset(datasetId, licenseId)
        .then(response => {
          const copyState = this.copyState();
          const dataset = copyState.datasets.find(d => d.persistenceId === datasetId);
          const license = dataset.licenses.find(l => l.persistenceId === licenseId);
          license.subscribed = true;
          this.setState(copyState);
          this.resetWidget(datasetId);
        });
    }
  }

  resetWidget(subscribedDatasetId) {
    for (let widgetId in this.missingSubscriptionMap) {
      if (this.missingSubscriptionMap[widgetId].indexOf(subscribedDatasetId) > -1) {
        const widget = WidgetService.getWidget(widgetId);
        this.publish(InternalEvent.Dashboard.CHART_RESET, widget);
      }
    }
  }

  show() {
    this.$modal.modal("open");
  }

  hide() {
    this.$modal.modal("close");
  }

  reload() {
    this.hide();
    this.props.onReload();
  }

  render() {
    return (
      <div id="subscription-modal" className={[styles.modal, "modal"].join(' ')} style={{width: 600}}>
        <div className="modal-content">
          <h5>Require Subscriptions</h5>
          <div className={styles.wrapper}>
            {
              this.state.displaySubscribeAll ?
                <a className={["waves-effect waves-light btn", styles.subscribeAllBtn].join(" ")}
                   onClick={this.subscribeAll}>Subscribe All</a>
                : null
            }
            <section>
              {
                this.state.datasets.map((d, i) => <DatasetLicenses dataset={d} onSubscribe={this.subscribeLicense}
                                                                   key={i}/>)
              }
            </section>
          </div>
        </div>
        <div className={styles.footer}>
          <button
            className={[styles.actionButton, "btn-flat modal-close waves-effect"].join(' ')}>OK
          </button>
        </div>
      </div>
    )
  }
}

class DatasetLicenses extends BaseComponent {
  render() {
    return (
      <div className={styles.datasetLicenses}>
        <div>{this.props.dataset.name}</div>
        <ul className={styles.datasetLicense}>
          {
            this.props.dataset.licenses.map((l, i) =>
              <li className={[styles.license].join(" ")} key={i}>
                <div className={styles.name}>{l.description}</div>
                {
                  l.subscribed ?
                    <a className={["waves-effect waves-light btn", styles.unsubscribeBtn].join(" ")}>Subscribed</a>
                    : <a className={["waves-effect waves-light btn", styles.subscribeBtn].join(" ")}
                         onClick={() => this.props.onSubscribe(this.props.dataset.persistenceId, l.persistenceId)}>Subscribe</a>
                }
              </li>
            )
          }
        </ul>
      </div>

    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/subscription/subscription.jsx